// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const toxtricity_amped_gmax: PokeData = {
  "id": 10219,
  "name": "toxtricity-amped-gmax",
  "height": 240,
  "weight": 10000,
  "base_experience": 176,
  "types": [
    PokeType.ELECTRIC,
    PokeType.POISON
  ],
  "api_moves": [],
  "moves": [
    "thunderbolt",
    "volt-switch",
    "poison-jab",
    "thunder-fang",
    "poison-gas",
    "zap-cannon",
    "electric-wrath",
    "sludge-bomb",
    "thunder-shock",
    "wild-charge",
    "poison-fang",
    "mortal-gas",
    "thunder-punch"
  ],
  "evolution_chain": {
    "id": 446,
    "item": null,
    "species": [
      {
        "name": "toxel",
        "order": 848,
        "types": [
          PokeType.ELECTRIC,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "toxtricity",
        "order": 849,
        "types": [
          PokeType.ELECTRIC,
          PokeType.POISON
        ],
        "evolves_from_species_id": 848,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 115,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
